import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import { FiEdit, FiPhone, FiMail } from "react-icons/fi";
import { HiOutlineCalendarDays } from "react-icons/hi2";
import { FiGlobe, FiDollarSign } from "react-icons/fi";
import { FiClock, FiLink } from "react-icons/fi";
import CompanyModal from "../../modals/lead-dashboard/CompanyModal";
import EditCompanyModal from "../../modals/lead-dashboard/EditModals/EditCompanyModal";

export default function CompanySidebar() {
  const [showModal, setShowModal] = useState(false);
const[editOpenModal,seteditOpenModal]=useState(false)
  return (
    <>
      <Card className="company-card shadow-sm mt-2 border-0">

        {/* HEADER */}
        <div className="company-header text-center position-relative">
          {/* <FiEdit className="edit-icon" onClick={() => setShowModal(true)} /> */}

          <div className="header-bg"></div>

          <div className="logo-wrapper">
            <img src="/assets/img/company/company-11.svg" alt="" />
          </div>

          <h5 className="mt-2 text-dark">
            BrightWave Innovations <span className="verified">✔</span>
          </h5>

          <p className="text-muted small mb-0">
            1861 Bayonne Ave, Manchester, NJ, 08759
          </p>
        </div>

        <Card.Body>

          {/* BASIC INFO */}
          <div className="section">
            <div className="section-title">
              Basic information <FiEdit onClick={() => seteditOpenModal(true)} />
            </div>

            <div className="info-row">
              <div className="left">
                <FiPhone /> Phone
              </div>
              <div className="right">(163) 2459 315</div>
            </div>

            <div className="info-row">
              <div className="left">
                <FiMail /> Email
              </div>
              <div className="right text-primary">email@example.com</div>
            </div>

            <div className="info-row">
              <div className="left">
                <HiOutlineCalendarDays /> Created On
              </div>
              <div className="right">24 July 2024, 11:45 pm</div>
            </div>
          </div>

          {/* OTHER INFO */}
          <div className="section">
            <div className="section-title">
              Other Information <FiEdit size={14} />
            </div>

            <div className="info-row">
              <div className="left">
                <FiGlobe /> Language
              </div>
              <div className="right">English</div>
            </div>

            <div className="info-row">
              <div className="left">
                <FiDollarSign /> Currency
              </div>
              <div className="right">United States dollar</div>
            </div>

            <div className="info-row">
              <div className="left">
                <FiClock /> Last Modified
              </div>
              <div className="right">27 Sep 24, 11:45 pm</div>
            </div>

            <div className="info-row">
              <div className="left">
                <FiLink /> Source
              </div>
              <div className="right">Paid Campaign</div>
            </div>
          </div>

          {/* TAGS */}
          <div className="section">
            <div className="section-title">Tags</div>
            <span className="badge tag-green me-2">Collab</span>
            <span className="badge tag-yellow">Rated</span>
          </div>

          {/* COMPANY */}
          <div className="section">
            <div className="section-title d-flex justify-content-between">
              Company
              <span className="add-new" onClick={() => setShowModal(true)}>
                + Add New
              </span>
            </div>

            <div className="company-item">
              <img src="/assets/img/company/company-11.svg" alt="" />
              <div>
                <p className="mb-0 fw-medium">BrightWave Innovations</p>
                <small className="text-muted">bwi.example.com</small>
              </div>
            </div>

            <div className="company-item">
              <img src="/assets/img/company/company-11.svg" alt="" />
              <div>
                <p className="mb-0 fw-medium">Stellar Dynamics</p>
                <small className="text-muted">sd.example.com</small>
              </div>
            </div>
          </div>

          {/* SOCIAL LINKS */}
          <div className="section">
            <div className="section-title">
              Social Links <FiEdit size={14} />
            </div>

            <div className="social-icons">
              <img src="/assets/img/social/social-01.svg" alt="" />
              <img src="/assets/img/social/social-02.svg" alt="" />
              <img src="/assets/img/social/social-03.svg" alt="" />
              <img src="/assets/img/social/social-04.svg" alt="" />
              <img src="/assets/img/social/social-05.svg" alt="" />
              <img src="/assets/img/social/social-06.svg" alt="" />
            </div>
          </div>

          {/* BUTTONS */}
          <div className="d-flex gap-2 mt-3">
            <Button variant="dark" className="w-50">Share</Button>
            <Button className="w-50 btn-orange">Delete</Button>
          </div>

        </Card.Body>
      </Card>
<EditCompanyModal show={editOpenModal} setShow={seteditOpenModal} />
      <CompanyModal show={showModal} setShow={setShowModal} />

      {/* EXACT STYLING */}
      <style>{`
        .company-card {
          border-radius: 10px;
          overflow: hidden;
        }

        .header-bg {
          height: 80px;
          background: linear-gradient(90deg, #ff6a00, #ffb347);
        }

        .logo-wrapper {
          margin-top: -25px;
        }

        .logo-wrapper img {
          width: 55px;
          height: 55px;
          background: #fff;
          border-radius: 50%;
          padding: 6px;
        }

        .verified {
          color: #28c76f;
          font-size: 14px;
        }

        .edit-icon {
          position: absolute;
          top: 10px;
          right: 10px;
          cursor: pointer;
        }

        .section {
          border-top: 1px solid #eee;
          padding: 15px 0;
        }

        .section-title {
          font-weight: 600;
          margin-bottom: 12px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .info-row {
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          font-size: 14px;
        }

        .left {
          display: flex;
          gap: 8px;
          color: #6c757d;
        }

        .right {
          color: #000;
          font-weight: 500;
        }

        .tag-green {
          background: #e6f7ee;
          color: #28c76f;
        }

        .tag-yellow {
          background: #fff4e5;
          color: #f2994a;
        }

        .add-new {
          color: #ff6a00;
          cursor: pointer;
        }

        .company-item {
          display: flex;
          gap: 10px;
          align-items: center;
          margin-top: 10px;
        }

        .company-item img {
          width: 32px;
          height: 32px;
        }

        .social-icons img {
          width: 30px;
          height: 30px;
          margin-right: 8px;
          cursor: pointer;
        }

        .btn-orange {
          background: #ff6a00;
          border: none;
        }
      `}</style>
    </>
  );
}